import { z } from 'zod';

/**
 * Site contract (CLAUDE.md §7.1 `sites`). The site-selector and `/api/sites` (M02)
 * satisfy this shape. Kept a list, never a hardcoded single site — many-sites-per-tenant
 * is the scale stance (00-PLAN §8).
 */
export const SiteSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  code: z.string().min(1),
  timezone: z.string().min(1), // IANA tz, e.g. "Africa/Johannesburg"
  // Nullable (not optional) so the shape matches a D1 row: the column always exists,
  // its value is null when unset. Avoids exactOptionalPropertyTypes friction at the API edge.
  lat: z.number().min(-90).max(90).nullable(),
  lng: z.number().min(-180).max(180).nullable(),
});

export type Site = z.infer<typeof SiteSchema>;

export const SiteListSchema = z.array(SiteSchema);
export type SiteList = z.infer<typeof SiteListSchema>;
